
import TranducerMessagesList from "./TranducerMessagesList";

export default TranducerMessagesList;